import { api } from '../api';

export interface GmailConfiguracao {
  client_id: string;
  client_secret: string;
  email_remetente: string;
  nome_remetente: string;
  assinatura_email: string;
  ativo: boolean;
  tem_refresh_token?: boolean;
  configurado?: boolean;
}

export interface EmailData {
  para: string;
  para_nome?: string;
  assunto: string;
  corpo_html?: string;
  corpo?: string;
  corpo_texto?: string;
}

export interface GmailResponse {
  sucesso: boolean;
  mensagem: string;
  dados?: any;
  erro?: string;
}

export const gmailService = {
  // Salvar configuração Gmail
  async salvarConfiguracao(configuracao: Partial<GmailConfiguracao>): Promise<GmailResponse> {
    try {
      // console.log('[GmailService] Salvando configuração Gmail:', {
        // email_remetente: configuracao.email_remetente,
        // timestamp: new Date().toISOString()
      // });

      const response = await api.post('/gmail/configuracao', configuracao);
      
      // console.log('[GmailService] Resposta da API - salvar configuração:', {
        // sucesso: response.data.sucesso,
        // mensagem: response.data.mensagem
      // });

      return response.data;
    } catch (error: any) {
      console.error('[GmailService] Erro ao salvar configuração:', {
        error,
        status: error?.response?.status,
        data: error?.response?.data,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: error?.response?.data?.mensagem || 'Erro ao salvar configuração Gmail',
        erro: error?.response?.data?.erro || error.message
      };
    }
  },

  // Buscar configuração Gmail
  async buscarConfiguracao(): Promise<GmailResponse> {
    try {
      // console.log('[GmailService] Buscando configuração Gmail');

      const response = await api.get('/gmail/configuracao');
      
      // console.log('[GmailService] Resposta da API - buscar configuração:', {
        // sucesso: response.data.sucesso,
        // configurado: response.data.dados?.configurado
      // });

      return response.data;
    } catch (error: any) {
      console.error('[GmailService] Erro ao buscar configuração:', {
        error,
        status: error?.response?.status,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: error?.response?.data?.mensagem || 'Erro ao buscar configuração Gmail',
        erro: error?.response?.data?.erro || error.message
      };
    }
  },

  // Iniciar autenticação OAuth2
  async iniciarAuth(client_id: string, client_secret: string): Promise<GmailResponse> {
    try {
      // console.log('[GmailService] Iniciando autenticação OAuth2:', {
        // client_id: client_id.substring(0, 10) + '...',
        // timestamp: new Date().toISOString()
      // });

      const response = await api.post('/gmail/auth/iniciar', {
        client_id,
        client_secret
      });
      
      // console.log('[GmailService] Resposta da API - iniciar auth:', {
        // sucesso: response.data.sucesso,
        // tem_auth_url: !!response.data.dados?.auth_url
      // });

      return response.data;
    } catch (error: any) {
      console.error('[GmailService] Erro ao iniciar autenticação:', {
        error,
        status: error?.response?.status,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: error?.response?.data?.mensagem || 'Erro ao iniciar autenticação Gmail',
        erro: error?.response?.data?.erro || error.message
      };
    }
  },

  // Testar configuração Gmail
  async testar(): Promise<GmailResponse> {
    try {
      // console.log('[GmailService] Testando configuração Gmail');

      const response = await api.post('/gmail/testar');
      
      // console.log('[GmailService] Resposta da API - testar:', {
        // sucesso: response.data.sucesso,
        // mensagem: response.data.mensagem
      // });

      return response.data;
    } catch (error: any) {
      console.error('[GmailService] Erro ao testar configuração:', {
        error,
        status: error?.response?.status,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: error?.response?.data?.mensagem || 'Erro ao testar configuração Gmail',
        erro: error?.response?.data?.erro || error.message
      };
    }
  },

  // Verificar conexão atual do usuário
  async verificarConexao(): Promise<GmailResponse> {
    try {
      // console.log('[GmailService] Verificando conexão Google atual');

      const response = await api.get('/gmail/verificar-conexao');
      
      // console.log('[GmailService] Resposta da API - verificar conexão:', {
        // sucesso: response.data.sucesso,
        // conectado: response.data.dados?.conectado
      // });

      return response.data;
    } catch (error: any) {
      console.error('[GmailService] Erro ao verificar conexão:', {
        error,
        status: error?.response?.status,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: error?.response?.data?.mensagem || 'Erro ao verificar conexão Gmail',
        erro: error?.response?.data?.erro || error.message
      };
    }
  },

  // Iniciar processo de conexão OAuth2 (nova versão simplificada)
  async conectarConta(): Promise<GmailResponse> {
    try {
      // console.log('[GmailService] Iniciando conexão OAuth2 da conta');

      // Obter cod_empresa do authService
      const authService = await import('../authService');
      const empresa = authService.authService.getEmpresa();
      
      if (!empresa || !empresa.id) {
        throw new Error('ACESSO NEGADO: Empresa não identificada para conexão');
      }

      // console.log('[GmailService] Obtendo URL de autorização:', {
        // cod_empresa: empresa.id,
        // timestamp: new Date().toISOString()
      // });

      const response = await api.get(`/gmail/conectar?cod_empresa=${empresa.id}`);
      
      if (response.data.sucesso && response.data.url) {
        // console.log('[GmailService] URL de autorização recebida - redirecionando:', {
          // url: response.data.url.substring(0, 100) + '...'
        // });
        
        // Redirecionar para autorização Google
        window.location.href = response.data.url;
        
        return response.data;
      }

      return response.data;
    } catch (error: any) {
      console.error('[GmailService] Erro ao conectar conta:', {
        error,
        status: error?.response?.status,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: error?.response?.data?.mensagem || 'Erro ao conectar conta Gmail',
        erro: error?.response?.data?.erro || error.message
      };
    }
  },

  // Desconectar conta Google
  async desconectarConta(): Promise<GmailResponse> {
    try {
      // console.log('[GmailService] Desconectando conta Google');

      const response = await api.delete('/gmail/auth/desconectar');
      
      // console.log('[GmailService] Resposta da API - desconectar:', {
        // sucesso: response.data.sucesso
      // });

      return response.data;
    } catch (error: any) {
      console.error('[GmailService] Erro ao desconectar conta:', {
        error,
        status: error?.response?.status,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: error?.response?.data?.mensagem || 'Erro ao desconectar conta Gmail',
        erro: error?.response?.data?.erro || error.message
      };
    }
  },

  // Enviar e-mail
  async enviarEmail(emailData: EmailData): Promise<GmailResponse> {
    try {
      // console.log('[GmailService] Enviando e-mail:', {
        // para: emailData.para,
        // assunto: emailData.assunto,
        // timestamp: new Date().toISOString()
      // });

      const response = await api.post('/gmail/enviar', emailData);
      
      // console.log('[GmailService] Resposta da API - enviar email:', {
        // sucesso: response.data.sucesso,
        // message_id: response.data.message_id
      // });

      return response.data;
    } catch (error: any) {
      console.error('[GmailService] Erro ao enviar e-mail:', {
        error,
        status: error?.response?.status,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: error?.response?.data?.mensagem || 'Erro ao enviar e-mail',
        erro: error?.response?.data?.erro || error.message
      };
    }
  },

  // Reconectar com TODOS os escopos (Gmail + Calendar)
  async reconectarComTodosEscopos(): Promise<GmailResponse> {
    try {
      // console.log('[GmailService] Iniciando reconexão com TODOS os escopos (Gmail + Calendar)');

      const response = await api.post('/gmail/reconectar');
      
      if (response.data.sucesso && response.data.dados?.authUrl) {
        // console.log('[GmailService] URL de reconexão obtida, redirecionando...');
        
        // Redirecionar para autorização do Google
        window.location.href = response.data.dados.authUrl;
        
        return {
          sucesso: true,
          mensagem: 'Redirecionando para reconexão...'
        };
      } else {
        throw new Error(response.data.mensagem || 'Erro ao obter URL de reconexão');
      }

    } catch (error: any) {
      console.error('[GmailService] Erro na reconexão:', {
        error,
        status: error?.response?.status,
        timestamp: new Date().toISOString()
      });

      return {
        sucesso: false,
        mensagem: error?.response?.data?.mensagem || 'Erro ao reconectar conta Google',
        erro: error?.response?.data?.erro || error.message
      };
    }
  },

  // Verificar se há parâmetros de callback na URL
  verificarCallback(): { sucesso?: boolean; erro?: string } {
    const urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.get('gmail_success') === 'true') {
      // Limpar parâmetros da URL
      window.history.replaceState({}, document.title, window.location.pathname);
      return { sucesso: true };
    }
    
    const erro = urlParams.get('gmail_error');
    if (erro) {
      // Limpar parâmetros da URL
      window.history.replaceState({}, document.title, window.location.pathname);
      return { erro };
    }
    
    return {};
  }
};
